import React, { useEffect, useMemo, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Card, Space, Tag } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import Cycle from 'app/entities/cycle/cycle';
import { getClasses } from 'app/entities/classe/classe.reducer';
import { getCycles, getCycleMatieres } from 'app/entities/cycle/cycle.reducer';

export const PedagogieConfig = (props: RouteComponentProps<{ ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const [matiereCount, setMatiereCount] = useState(0);
  const cycleList = useAppSelector(state => state.cycle.entities);
  const classeList = useAppSelector(state => state.classe.entities);
  const ecoleId = props.match.params.ecoleid;
  const refreshSummary = async () => {
    const response = await dispatch(getCycles(ecoleId)).unwrap();
    const cycles = response.data || [];
    dispatch(getClasses(ecoleId));
    const counts = await Promise.all((cycles || []).map(cycle => dispatch(getCycleMatieres(cycle.id)).unwrap()));
    setMatiereCount(counts.reduce((total, rows) => total + (rows?.length || 0), 0));
  };

  useEffect(() => {
    refreshSummary();
  }, [ecoleId]);

  const openCycleConfiguration = (cycleId: string) => {
    props.history.push(`/configuration-pedagogie/${ecoleId}/wizard/${cycleId}`);
  };

  const summaryText = useMemo(
    () =>
      `${cycleList.length} cycle${cycleList.length > 1 ? 's' : ''}, ${classeList.length} classe${
        classeList.length > 1 ? 's' : ''
      }, ${matiereCount} matière${matiereCount > 1 ? 's' : ''} configurée${matiereCount > 1 ? 's' : ''}`,
    [classeList.length, cycleList.length, matiereCount]
  );

  return (
    <Card style={{ borderRadius: 16, border: '1px solid #f3f3f3', boxShadow: '0 6px 18px rgba(0,0,0,0.05)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, flexWrap: 'wrap', marginBottom: 8 }}>
        <Space direction="vertical" size={4}>
          <h2 style={{ margin: 0 }}>Configuration de la pédagogie</h2>
          <Tag color="orange">{summaryText}</Tag>
        </Space>
      </div>
      <Cycle {...props} onConfigureCycle={openCycleConfiguration} />
    </Card>
  );
};

export default PedagogieConfig;
